import { render } from "./AddScheduleType.vue?vue&type=template&id=ddf56702&scoped=true"
import script from "./AddScheduleType.vue?vue&type=script&lang=js"
export * from "./AddScheduleType.vue?vue&type=script&lang=js"

import "./AddScheduleType.vue?vue&type=style&index=0&id=ddf56702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf56702"]])

export default __exports__